import React, { useEffect, useState } from "react";
import AddStudent from "../default/components/AddStudents";
import ViewStudentData from "./components/ViewStudentData";

// Icon Imports
import {
  MdNoteAdd,
  MdTableView,
} from "react-icons/md";

interface TabProps {
  icon?: React.ReactNode;
  label: string;
  content: React.ReactNode;
}

interface TabContentProps {
  tabId: string;
}


const tabsData: TabProps[] = [
  { icon:<MdNoteAdd className="h-6 w-6"/>, label: 'Add Student', content: <p>
    <span className="font-semibold text-2xl flex justify-center text-indigo-600 font-[font-serif] text-shadow-lg/20">Add a New Student</span></p> },
  { icon:<MdTableView className="h-6 w-6"/>, label: 'View Student', content: <p><span className="font-semibold text-2xl flex justify-center text-indigo-600 font-[font-serif]">View Student Details</span></p> },
];



const TabContent: React.FC<TabContentProps> = ({ tabId }) => {



  useEffect(() => {
    setTimeout(() => {
      // setData(`Updated content for ${tabId}`);
    }, 300);
  }, [tabId]); // Re-run effect when tabId changes

  return (
    <div>
      {tabId === 'view-student' && (
     /*    <ViewStudents /> */
        <ViewStudentData/>
      )}
      {tabId === 'add-student' && (
        <AddStudent />
      )}
    </div>
  );
};

/* const handleTabLoad = (tabName: string) => {
  console.log(`Tab "${tabName}" has been loaded.`);
  // Perform any other side effects here, such as fetching data
  // or updating the component state based on the selected tab.
  return (
    <div className="mt-4 p-4 bg-white rounded shadow rounded-[10px] shadow-md ">
    {tabName === 'Add Student' && (
      <AddStudent  />
    )}
    {tabName === 'View Student' && (
      <ViewStudents  />
    )}
  </div>
);
}; */



const StudentsDashboard = () => {
    const [activeTab, setActiveTab] = useState(0);
 
    const handleTabClick = (tabIndex: number) => {
        setActiveTab(tabIndex);
   };


/*     useEffect(() => {
      handleTabLoad(tabsData[activeTab].label);
    }, [activeTab]); */

  return (
    <div className="col-span-4 lg:!mb-0 mt-4 block rounded-lg rounded-full bg-gradient-to-b from-white/50 to-white/10" >
   
  
      {/* Tab Headers */}
      <div className="flex rounded rounded-lg bg-gradient-to-r from-white to-indigo-200 p-2">
        {tabsData.map((tab, index) => (
          <button
            key={index}
            className={`
              flex items-center space-x-2 px-4 py-3 text-sm font-medium transition-colors duration-200 rounded-t-lg 
              ${activeTab === index
                ? 'text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-400 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 '
                : 'text-gray-800 hover:text-blue-600 hover:border-b-2 hover:border-blue-500'
              }
            `}
            onClick={() => { handleTabClick(index) }}
          >
            {tab.icon}
            <span>{tab.label}</span>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      
      <div className="mt-4 p-4 bg-white rounded shadow rounded-[10px] shadow-md ">
        {tabsData[activeTab].content} 
         {tabsData[activeTab].label === 'Add Student' && (
          <TabContent tabId="add-student" />
        )}
        {tabsData[activeTab].label === 'View Student' && (
          <TabContent tabId="view-student" />
        )}
      </div>
    </div>

  );

};

export default StudentsDashboard;
